export default "__VITE_ASSET__Ch2i8DtO__"